export default {
  // ── 导航 ──────────────────────────────────────────────────────────
  'landing.nav.features': '产品功能',
  'landing.nav.architecture': '平台架构',
  'landing.nav.scenarios': '应用场景',
  'landing.nav.ecosystem': '生态集成',
  'landing.nav.cases': '客户案例',
  'landing.nav.pricing': '定价',
  'landing.nav.login': '登录',
  'landing.nav.freeTrial': '免费试用',

  // ── Stats 统计区 ───────────────────────────────────────────────────
  'landing.stats.efficiency.label': '平均效率提升',
  'landing.stats.efficiency.desc': '对比传统人工方式',
  'landing.stats.accuracy.label': '知识检索准确率',
  'landing.stats.accuracy.desc': '企业私有知识库问答',
  'landing.stats.customers.label': '落地企业客户',
  'landing.stats.customers.desc': '覆盖 10+ 行业',

  // ── Hero ──────────────────────────────────────────────────────────
  'landing.hero.badge': '企业级 AI 协作平台',
  'landing.hero.title.line1': '让每个团队',
  'landing.hero.title.line2': '都拥有专属',
  'landing.hero.title.highlight': 'AI 协作大脑',
  'landing.hero.subtitle': '整合知识库、文档处理与智能问答，帮助企业团队告别重复劳动，让知识高效流动。',
  'landing.hero.stat.customers': '企业客户',
  'landing.hero.stat.uptime': '服务可用率',
  'landing.hero.stat.efficiency': '效率提升',
  'landing.hero.cta.start': '免费试用',
  'landing.hero.cta.demo': '预约演示',
  'landing.hero.trust.appstore': '4.9 分 · App Store 好评',
  'landing.hero.trust.noCard': '无需信用卡',
  'landing.hero.badge.todayDocs': '今日处理文档',
  'landing.hero.badge.increase': '↑ 12% 较昨日',
  'landing.hero.badge.contractDone': '合同自动审核完成',
  'landing.hero.badge.timeSaved': '刚刚 · 节省 2.5 小时',
  'landing.hero.trusted': '受到行业领先企业信赖',
  'landing.hero.preview.placeholder': '产品截图 / 演示视频',
  'landing.hero.preview.hint': '替换 img src 即可显示真实内容',

  // ── Features 核心功能 ───────────────────────────────────────────────
  'landing.features.badge': '核心功能',
  'landing.features.title': '重新定义企业 AI 能力边界',
  'landing.features.subtitle': '六大核心能力模块，覆盖企业 AI 化转型全场景，开箱即用，快速集成',
  'landing.features.learnMore': '了解更多 →',

  'landing.feature.knowledge.title': '知识智能助手',
  'landing.feature.knowledge.desc': '基于企业私有知识库构建专属 AI 助手，精准问答，秒级响应，告别信息孤岛。',
  'landing.feature.knowledge.tag1': 'RAG 检索',
  'landing.feature.knowledge.tag2': '多轮对话',
  'landing.feature.knowledge.tag3': '引用溯源',

  'landing.feature.document.title': '文档智能处理',
  'landing.feature.document.desc': '自动解析 PDF、Word、Excel 等格式文档，提取结构化信息，批量处理效率提升 10 倍。',
  'landing.feature.document.tag1': 'OCR 识别',
  'landing.feature.document.tag2': '自动摘要',
  'landing.feature.document.tag3': '结构提取',

  'landing.feature.workflow.title': '流程自动化',
  'landing.feature.workflow.desc': '连接企业现有系统，构建 AI 驱动的自动化工作流，减少重复劳动，释放团队创造力。',
  'landing.feature.workflow.tag1': '工作流编排',
  'landing.feature.workflow.tag2': '系统集成',
  'landing.feature.workflow.tag3': '定时任务',

  'landing.feature.security.title': '企业级安全',
  'landing.feature.security.desc': '私有化部署支持，数据不出企业，满足金融、医疗、政务等行业合规要求。',
  'landing.feature.security.tag1': '私有部署',
  'landing.feature.security.tag2': '数据脱敏',
  'landing.feature.security.tag3': '审计日志',

  'landing.feature.model.title': '多模型管理',
  'landing.feature.model.desc': '统一接入 GPT-4、Claude、文心、通义等主流大模型，智能路由，按需切换。',
  'landing.feature.model.descCn': '统一接入 DeepSeek、Kimi、文心、通义等主流大模型，智能路由，按需切换。',
  'landing.feature.model.tag1': '模型路由',
  'landing.feature.model.tag2': '成本优化',
  'landing.feature.model.tag3': 'A/B 测试',

  'landing.feature.analytics.title': '数据分析洞察',
  'landing.feature.analytics.desc': '自然语言查询数据库，一句话生成图表报告，让每个人都成为数据分析师。',
  'landing.feature.analytics.tag1': 'NL2SQL',
  'landing.feature.analytics.tag2': '可视化',
  'landing.feature.analytics.tag3': '报告生成',

  // ── Architecture 平台架构 ───────────────────────────────────────────
  'landing.arch.badge': '平台架构',
  'landing.arch.title': '四层架构，稳固可靠',
  'landing.arch.subtitle': '点击各层查看详细能力说明，了解完整技术栈',
  'landing.arch.integrations': '企业系统 · 钉钉 · 飞书 · 微信 · 自定义 API',

  'landing.arch.app.label': '应用层',
  'landing.arch.app.sublabel': 'Application Layer',
  'landing.arch.app.item.0': '知识助手',
  'landing.arch.app.item.1': '文档智能',
  'landing.arch.app.item.2': '流程机器人',
  'landing.arch.app.item.3': '数据分析',
  'landing.arch.app.desc': '面向业务的 AI 应用，可快速定制部署。支持网页端、移动端、API 三种接入方式。',

  'landing.arch.platform.label': '平台层',
  'landing.arch.platform.sublabel': 'Platform Layer',
  'landing.arch.platform.item.0': 'Prompt 管理',
  'landing.arch.platform.item.1': '对话编排',
  'landing.arch.platform.item.2': '工作流引擎',
  'landing.arch.platform.item.3': '权限管控',
  'landing.arch.platform.desc': '核心平台能力，提供低代码 AI 应用构建工具，模型路由与成本优化，全链路监控。',

  'landing.arch.model.label': '模型层',
  'landing.arch.model.sublabel': 'Model Layer',
  'landing.arch.model.item.0': 'GPT-4o',
  'landing.arch.model.item.1': 'Claude 3.5',
  'landing.arch.model.item.2': '文心一言',
  'landing.arch.model.item.3': '通义千问',
  'landing.arch.model.desc': '统一接入主流大语言模型，支持私有化部署开源模型，智能路由降低推理成本。',

  'landing.arch.data.label': '数据层',
  'landing.arch.data.sublabel': 'Data Layer',
  'landing.arch.data.item.0': '向量数据库',
  'landing.arch.data.item.1': '企业知识库',
  'landing.arch.data.item.2': '结构化数据',
  'landing.arch.data.item.3': '文件存储',
  'landing.arch.data.desc': '企业数据统一治理，向量化索引加速检索，确保 AI 回答有据可查、安全可控。',

  // ── Scenarios 应用场景 ─────────────────────────────────────────────
  'landing.scenarios.badge': '应用场景',
  'landing.scenarios.title': '覆盖企业 AI 化全场景',
  'landing.scenarios.subtitle': '从个人效率工具到全流程自动化，满足不同规模企业的差异化需求',
  'landing.scenarios.viewSolution': '查看完整方案 →',
  'landing.scenarios.coreCaps': '核心能力点',
  'landing.scenarios.implemented': '已有 200+ 企业在此场景落地',
  'landing.scenarios.caseLib': '案例库 →',

  'landing.scenario.office.tab': '企业 AI 办公',
  'landing.scenario.office.title': '让每位员工都有 AI 助理',
  'landing.scenario.office.desc': '智能会议纪要、邮件起草、报告生成、日程管理——将繁琐工作自动化，让团队专注于高价值创造。',
  'landing.scenario.office.metric.0.label': '减少重复工作',
  'landing.scenario.office.metric.0.value': '68%',
  'landing.scenario.office.metric.1.label': '文档处理提速',
  'landing.scenario.office.metric.1.value': '10x',
  'landing.scenario.office.metric.2.label': '员工满意度',
  'landing.scenario.office.metric.2.value': '94%',
  'landing.scenario.office.feature.0': '智能会议助手',
  'landing.scenario.office.feature.1': '邮件自动回复',
  'landing.scenario.office.feature.2': '报告一键生成',
  'landing.scenario.office.feature.3': 'PPT 内容助手',
  'landing.scenario.office.feature.4': '多语言翻译',
  'landing.scenario.office.feature.5': '日程智能排期',

  'landing.scenario.knowledge.tab': '知识助手',
  'landing.scenario.knowledge.title': '让企业知识活起来',
  'landing.scenario.knowledge.desc': '接入产品手册、规章制度、行业文献，构建专属知识问答系统。新员工上手只需一天，客服响应速度提升 5 倍。',
  'landing.scenario.knowledge.metric.0.label': '知识检索准确率',
  'landing.scenario.knowledge.metric.0.value': '97%',
  'landing.scenario.knowledge.metric.1.label': '新员工培训提速',
  'landing.scenario.knowledge.metric.1.value': '75%',
  'landing.scenario.knowledge.metric.2.label': '客服响应提速',
  'landing.scenario.knowledge.metric.2.value': '5x',
  'landing.scenario.knowledge.feature.0': '多格式文档导入',
  'landing.scenario.knowledge.feature.1': '智能向量检索',
  'landing.scenario.knowledge.feature.2': '引用溯源',
  'landing.scenario.knowledge.feature.3': '权限分级管理',
  'landing.scenario.knowledge.feature.4': '知识图谱',
  'landing.scenario.knowledge.feature.5': '持续学习更新',

  'landing.scenario.document.tab': '文档智能',
  'landing.scenario.document.title': '文档处理效率飞跃',
  'landing.scenario.document.desc': '合同审查、财务报表分析、法律文书解读——AI 在秒级内完成原本需要数小时的专业文档处理工作。',
  'landing.scenario.document.metric.0.label': '合同审查提速',
  'landing.scenario.document.metric.0.value': '20x',
  'landing.scenario.document.metric.1.label': '信息提取准确率',
  'landing.scenario.document.metric.1.value': '98.5%',
  'landing.scenario.document.metric.2.label': '年均节省成本',
  'landing.scenario.document.metric.2.value': '¥50万+',
  'landing.scenario.document.feature.0': 'PDF/Word 深度解析',
  'landing.scenario.document.feature.1': '合同关键条款提取',
  'landing.scenario.document.feature.2': '财报智能摘要',
  'landing.scenario.document.feature.3': '多文档比对分析',
  'landing.scenario.document.feature.4': '风险自动标注',
  'landing.scenario.document.feature.5': '批量处理',

  'landing.scenario.workflow.tab': '自动化流程',
  'landing.scenario.workflow.title': '业务流程全面提速',
  'landing.scenario.workflow.desc': '可视化流程编排，将审批、报表、数据同步等重复工作交给 AI，连接钉钉、飞书、SAP、Salesforce 等系统。',
  'landing.scenario.workflow.metric.0.label': '流程自动化率',
  'landing.scenario.workflow.metric.0.value': '85%',
  'landing.scenario.workflow.metric.1.label': '错误率降低',
  'landing.scenario.workflow.metric.1.value': '92%',
  'landing.scenario.workflow.metric.2.label': 'ROI 回收周期',
  'landing.scenario.workflow.metric.2.value': '3个月',
  'landing.scenario.workflow.feature.0': '可视化流程设计器',
  'landing.scenario.workflow.feature.1': '条件分支智能判断',
  'landing.scenario.workflow.feature.2': '多系统数据同步',
  'landing.scenario.workflow.feature.3': '异常自动告警',
  'landing.scenario.workflow.feature.4': '流程版本管理',
  'landing.scenario.workflow.feature.5': 'API 开放集成',

  // ── Ecosystem 生态集成 ─────────────────────────────────────────────
  'landing.ecosystem.badge': '生态集成',
  'landing.ecosystem.title': '连接企业数字生态',
  'landing.ecosystem.subtitle': '预置 200+ 企业系统连接器，开箱即用，支持自定义 API 接入任意平台',
  'landing.ecosystem.enterpriseSystems': '企业系统连接',
  'landing.ecosystem.llmSupport': '大语言模型支持',

  'landing.integration.category.collab': '协作',
  'landing.integration.category.database': '数据库',
  'landing.integration.category.search': '搜索',
  'landing.integration.category.storage': '存储',
  'landing.integration.category.mq': '消息队列',

  'landing.api.rest.desc': '标准 RESTful 接口规范',
  'landing.api.webhook.desc': '实时事件推送',
  'landing.api.sdk.desc': 'Python / Node / Java',
  'landing.api.security.label': '企业级安全',
  'landing.api.security.desc': 'SSO / OAuth2 / SAML',

  // ── Cases 客户案例 ─────────────────────────────────────────────────
  'landing.cases.badge': '客户案例',
  'landing.cases.title': '500+ 企业的共同选择',
  'landing.cases.subtitle': '来自金融、制造、零售、政务等行业的真实落地案例',
  'landing.cases.industryLabel': '{industry} 行业',
  'landing.cases.coveredIndustries': '覆盖行业',

  'landing.case.bank.company': '某头部股份制银行',
  'landing.case.bank.industry': '金融',
  'landing.case.bank.quote': '原来需要 3 个资深合规专员审一周的文件，现在 AI 两小时就能完成初审，质量更高。',
  'landing.case.bank.author': '某行合规总监',
  'landing.case.bank.result.0.metric': '审查效率提升',
  'landing.case.bank.result.0.value': '15x',
  'landing.case.bank.result.1.metric': '合规风险降低',
  'landing.case.bank.result.1.value': '78%',
  'landing.case.bank.result.2.metric': '年节省人力成本',
  'landing.case.bank.result.2.value': '¥380万',

  'landing.case.mfg.company': '某大型制造集团',
  'landing.case.mfg.industry': '制造',
  'landing.case.mfg.quote': '我们把 20 年的工艺知识全部数字化，现在新员工三周就能上岗，这在以前无法想象。',
  'landing.case.mfg.author': '某集团 CIO',
  'landing.case.mfg.result.0.metric': '新员工培训周期',
  'landing.case.mfg.result.0.value': '缩短 80%',
  'landing.case.mfg.result.1.metric': '技术问题响应时效',
  'landing.case.mfg.result.1.value': '提升 12x',
  'landing.case.mfg.result.2.metric': '年度培训成本节省',
  'landing.case.mfg.result.2.value': '¥520万',

  'landing.case.ecom.company': '某互联网电商平台',
  'landing.case.ecom.industry': '电商',
  'landing.case.ecom.quote': '大促期间客服接入量峰值超 50 万次，AI 扛住了所有压力，且客户满意度比以前还高。',
  'landing.case.ecom.author': '某平台客服负责人',
  'landing.case.ecom.result.0.metric': '自动解决率',
  'landing.case.ecom.result.0.value': '83%',
  'landing.case.ecom.result.1.metric': '客服人力节省',
  'landing.case.ecom.result.1.value': '60%',
  'landing.case.ecom.result.2.metric': '用户满意度 NPS',
  'landing.case.ecom.result.2.value': '+42分',

  'landing.industry.0': '金融银行',
  'landing.industry.1': '制造业',
  'landing.industry.2': '零售电商',
  'landing.industry.3': '医疗健康',
  'landing.industry.4': '政务服务',
  'landing.industry.5': '教育培训',
  'landing.industry.6': '房地产',
  'landing.industry.7': '物流运输',
  'landing.industry.8': '法律服务',
  'landing.industry.9': '能源化工',

  // ── Security 安全 ──────────────────────────────────────────────────
  'landing.security.title': '企业级安全，值得信赖',
  'landing.security.subtitle': '通过国际主流安全认证，支持私有化部署，让数据真正留在企业手中',
  'landing.security.footer': '私有化部署可选 · 数据完全在您的控制下 · ',
  'landing.security.whitepaper': '查看安全白皮书 →',

  'landing.security.encrypt.title': '数据全程加密',
  'landing.security.encrypt.badge': 'ISO 27001 认证',
  'landing.security.encrypt.desc': '传输与存储均采用银行级加密，定期安全审计，确保企业数据绝对安全。',
  'landing.security.access.title': '细粒度访问控制',
  'landing.security.access.badge': 'SOC 2 Type II',
  'landing.security.access.desc': '三级权限体系，SSO / OAuth2 / SAML 全支持，满足企业合规审查要求。',
  'landing.security.compliance.title': '合规保障',
  'landing.security.compliance.badge': 'GDPR 合规',
  'landing.security.compliance.desc': '支持私有化部署，数据完全在您的控制下，符合国内外隐私法规要求。',

  // ── Pricing 定价 ───────────────────────────────────────────────────
  'landing.pricing.badge': '方案与定价',
  'landing.pricing.title': '为您的组织选择合适的方案',
  'landing.pricing.subtitle': '从免费体验到私有化部署，满足不同规模企业的需求',
  'landing.pricing.footer': '所有方案均包含 14 天免费试用 · 无需信用卡 · 随时取消',

  'landing.pricing.starter.name': '标准版',
  'landing.pricing.starter.price': '免费',
  'landing.pricing.starter.priceNote': '永久免费',
  'landing.pricing.starter.desc': '适合初步体验 AI 协作能力',
  'landing.pricing.starter.cta': '开始使用',
  'landing.pricing.starter.feature.0': '基础知识助手',
  'landing.pricing.starter.feature.1': '文档上传 20 个',
  'landing.pricing.starter.feature.2': '5 人团队',
  'landing.pricing.starter.feature.3': '标准技术支持',
  'landing.pricing.starter.feature.4': '社区版更新',

  'landing.pricing.pro.name': '专业版',
  'landing.pricing.pro.price': '联系获取',
  'landing.pricing.pro.priceNote': '按需定制',
  'landing.pricing.pro.desc': '适合中小企业团队，全面解锁 AI 能力',
  'landing.pricing.pro.cta': '联系销售',
  'landing.pricing.pro.badge': '最受欢迎',
  'landing.pricing.pro.feature.0': '全部标准版功能',
  'landing.pricing.pro.feature.1': '无限文档上传',
  'landing.pricing.pro.feature.2': '无限用户',
  'landing.pricing.pro.feature.3': 'API 接入',
  'landing.pricing.pro.feature.4': '高级数据分析',
  'landing.pricing.pro.feature.5': '专属客户成功经理',

  'landing.pricing.enterprise.name': '旗舰版',
  'landing.pricing.enterprise.price': '定制报价',
  'landing.pricing.enterprise.priceNote': '私有化 · 定制化',
  'landing.pricing.enterprise.desc': '适合大型企业，完全可控的私有化方案',
  'landing.pricing.enterprise.cta': '获取报价',
  'landing.pricing.enterprise.feature.0': '全部专业版功能',
  'landing.pricing.enterprise.feature.1': '私有化部署',
  'landing.pricing.enterprise.feature.2': '专属实施顾问',
  'landing.pricing.enterprise.feature.3': 'SLA 99.9% 保障',
  'landing.pricing.enterprise.feature.4': '定制系统集成',
  'landing.pricing.enterprise.feature.5': '安全审计与合规',

  // ── CTA ───────────────────────────────────────────────────────────
  'landing.cta.title1': '准备好让',
  'landing.cta.titleHighlight': ' AI ',
  'landing.cta.title2': '改变您的企业了吗？',
  'landing.cta.subtitle': '加入 500+ 领先企业，用 {title} 解锁 AI 效率新边界。14 天免费体验，专属顾问陪跑上线。',
  'landing.cta.emailPlaceholder': '请输入企业邮箱',
  'landing.cta.startFree': '免费开始使用',
  'landing.cta.emailInvalid': '请输入有效的企业邮箱',
  'landing.cta.mailSubject': '免费试用申请',
  'landing.cta.mailBody': '您好，我希望申请免费试用。我的企业邮箱：{email}',
  'landing.cta.perk.0': '14 天免费试用，无需信用卡',
  'landing.cta.perk.1': '专属实施顾问 1v1 陪跑',
  'landing.cta.perk.2': '数据安全，可私有化部署',
  'landing.cta.perk.3': '7×24 小时技术支持',

  // ── Footer ────────────────────────────────────────────────────────
  'landing.footer.brand.desc': '为企业构建 AI 智能应用层平台，让 AI 真正赋能业务增长。',
  'landing.footer.product': '产品',
  'landing.footer.solution': '解决方案',
  'landing.footer.resource': '资源',
  'landing.footer.contact': '联系我们',
  'landing.footer.copyright': '保留所有权利。',

  'landing.footer.product.0': '知识助手',
  'landing.footer.product.1': '文档智能',
  'landing.footer.product.2': '流程自动化',
  'landing.footer.product.3': '数据分析',
  'landing.footer.product.4': '企业 API',

  'landing.footer.solution.0': '金融行业',
  'landing.footer.solution.1': '制造业',
  'landing.footer.solution.2': '零售电商',
  'landing.footer.solution.3': '医疗健康',
  'landing.footer.solution.4': '政务服务',

  'landing.footer.resource.0': '开发文档',
  'landing.footer.resource.1': '博客',
  'landing.footer.resource.2': '案例研究',
  'landing.footer.resource.3': '视频教程',
  'landing.footer.resource.4': '技术社区',

  'landing.footer.contact.0.label': '商务合作',
  'landing.footer.contact.0.val': 'zhiyuwk@126.com',
  'landing.footer.contact.1.label': '技术支持',
  'landing.footer.contact.1.val': 'docfluxa@126.com',

  'landing.footer.legal.0': '隐私政策',
  'landing.footer.legal.1': '服务条款',
  'landing.footer.legal.2': '安全白皮书',
};
